module.exports = __webpack_public_path__ + "media/loader_desk_def.aaa605b0.mp4";